import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import Carousel from '@/components/Carousel';

export const VariantCarousel: React.FC<{
  variant: Queries.VariantPageQuery['variant'];
  isHemX: boolean;
  isSticky?: boolean;
}> = ({ variant, isHemX, isSticky }): JSX.Element => {
  if (!variant.slideshow || variant.slideshow.length === 0) {
    return null;
  }

  return (
    <Carousel
      slides={variant.slideshow.map((image, index) => (
        <GatsbyImage
          key={image.url}
          image={image.gatsbyImageData}
          alt={`${variant.productName} ${variant.variantName}, Art. no. ${
            variant.sku
          } (image ${index + 1})`}
          loading="eager"
        />
      ))}
      thumbnails={variant.slideshowThumbnails.map((image, index) => (
        <GatsbyImage
          key={image.url}
          image={image.gatsbyImageData}
          alt={`${variant.productName} ${variant.variantName}, Art. no. ${
            variant.sku
          } (image ${index + 1})`}
        />
      ))}
      slideWidth="100%"
      downloads={variant.slideshow}
      isHemX={isHemX}
      gap={false}
      isSticky={isSticky}
    />
  );
};
